var React = require('react');

function IcLinkOff (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.1504 19.6652L18.7402 21.0754L14.7305 17.0647H13V15.3352L10.7305 13.0647H8V11.0647H8.73047L6.66016 8.99532C5.11027 9.1653 3.90057 10.4748 3.90039 12.0647C3.90039 13.7747 5.29 15.1652 7 15.1652H11V17.0647H7C4.24 17.0647 2 14.8247 2 12.0647C2.00014 9.9748 3.29045 8.18449 5.11035 7.44453L2 4.33516L3.41016 2.925L20.1504 19.6652ZM17 7.06465C19.7599 7.06465 21.9998 9.30481 22 12.0647C22 13.8547 21.0499 15.4249 19.6299 16.3049L18.2305 14.9055C19.3303 14.4354 20.0996 13.3346 20.0996 12.0647C20.0994 10.3548 18.7099 8.96504 17 8.96504H13V7.06465H17ZM16 12.675L14.3896 11.0647H16V12.675Z","fill":"currentColor"}));
}

IcLinkOff.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IcLinkOff;

IcLinkOff.default = IcLinkOff;
